import { WebApiService } from '../../../../plugins/webApiService'
import { SendRequestModel } from '../../../../plugins/models/SendRequestModel'
import WeeekOptionsCheckEnableRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsCheckEnableRequest';
import WeeekOptionsSwitchEnableRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsSwitchEnableRequest';
import WeeekOptionsUpdateApiKeyRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsUpdateApiKeyRequest';
import WeeekOptionsUpsertTypesRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsUpsertTypesRequest';
import WeeekOptionsUpsertPrioritiesRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsUpsertPrioritiesRequest';
import WeeekOptionsUpsertStatusesRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsUpsertStatusesRequest';
import WeeekOptionsUpsertTagsRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsUpsertTagsRequest';
import WeeekOptionsGetProjectOptionsRequest from '../../../../project-manager/weeek/web/models/weeek-save-options-ws-controller/request/WeeekOptionsGetProjectOptionsRequest';
import WeeekOptionsGetTagsRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsGetTagsRequest';
import WeeekOptionsGetTypesRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsGetTypesRequest';
import WeeekOptionsGetStatusesRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsGetStatusesRequest';
import WeeekOptionsGetPrioritiesRequest from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/request/WeeekOptionsGetPrioritiesRequest';
import WsResponseModelT from '../../../../schema-builder/server/models/WsResponseModelT';
import WeeekOptionsCheckEnableResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsCheckEnableResponse';
import WeeekOptionsSwitchEnableResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsSwitchEnableResponse';
import WeeekOptionsUpsertTypesResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsUpsertTypesResponse';
import WeeekOptionsUpsertPrioritiesResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsUpsertPrioritiesResponse';
import WeeekOptionsUpsertStatusesResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsUpsertStatusesResponse';
import WeeekOptionsUpsertTagsResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsUpsertTagsResponse';
import WeeekOptionsGetProjectOptionsResponse from '../../../../project-manager/weeek/web/models/weeek-save-options-ws-controller/response/WeeekOptionsGetProjectOptionsResponse';
import WeeekOptionsGetTagsResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsGetTagsResponse';
import WeeekOptionsGetTypesResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsGetTypesResponse';
import WeeekOptionsGetStatusesResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsGetStatusesResponse';
import WeeekOptionsGetPrioritiesResponse from '../../../../project-manager/weeek/web/models/weeek-options-ws-controller/response/WeeekOptionsGetPrioritiesResponse';

/**
 * * Контроллер для работы с настройками
 */
export default class WeeekOptionsWsController {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Проверка включения интеграции проекта
	 */
	async CheckEnable(request: WeeekOptionsCheckEnableRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'CheckEnable',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Переключение настройки включения/выключения интеграции с Weeek
	 */
	async SwitchEnable(request: WeeekOptionsSwitchEnableRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'SwitchEnable',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение ключа апи в проекте
	 */
	async UpdateApiKey(request: WeeekOptionsUpdateApiKeyRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'UpdateApiKey',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async UpsertTypes(request: WeeekOptionsUpsertTypesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'UpsertTypes',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async UpsertPriorities(request: WeeekOptionsUpsertPrioritiesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'UpsertPriorities',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async UpsertStatuses(request: WeeekOptionsUpsertStatusesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'UpsertStatuses',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async UpsertTags(request: WeeekOptionsUpsertTagsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'UpsertTags',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение настроек проекта
	 */
	async GetProjectOptions(request: WeeekOptionsGetProjectOptionsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'GetProjectOptions',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сопоставления тегов
	 */
	async GetTags(request: WeeekOptionsGetTagsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'GetTags',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сопоставления типов
	 */
	async GetTypes(request: WeeekOptionsGetTypesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'GetTypes',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сопоставления тегов
	 */
	async GetStatuses(request: WeeekOptionsGetStatusesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'GetStatuses',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сопоставления тегов
	 */
	async GetPriorities(request: WeeekOptionsGetPrioritiesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Weeek',
			Controller: 'WeeekOptionsWsController',
			Method: 'GetPriorities',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Проверка включения интеграции проекта
	 */
	async checkEnableAsync(request: WeeekOptionsCheckEnableRequest): Promise<WeeekOptionsCheckEnableResponse> {
		return new Promise<WeeekOptionsCheckEnableResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'CheckEnable',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsCheckEnableResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsCheckEnableResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Переключение настройки включения/выключения интеграции с Weeek
	 */
	async switchEnableAsync(request: WeeekOptionsSwitchEnableRequest): Promise<WeeekOptionsSwitchEnableResponse> {
		return new Promise<WeeekOptionsSwitchEnableResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'SwitchEnable',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsSwitchEnableResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsSwitchEnableResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение ключа апи в проекте
	 */
	async updateApiKeyAsync(request: WeeekOptionsUpdateApiKeyRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'UpdateApiKey',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async upsertTypesAsync(request: WeeekOptionsUpsertTypesRequest): Promise<WeeekOptionsUpsertTypesResponse> {
		return new Promise<WeeekOptionsUpsertTypesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'UpsertTypes',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsUpsertTypesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsUpsertTypesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async upsertPrioritiesAsync(request: WeeekOptionsUpsertPrioritiesRequest): Promise<WeeekOptionsUpsertPrioritiesResponse> {
		return new Promise<WeeekOptionsUpsertPrioritiesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'UpsertPriorities',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsUpsertPrioritiesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsUpsertPrioritiesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async upsertStatusesAsync(request: WeeekOptionsUpsertStatusesRequest): Promise<WeeekOptionsUpsertStatusesResponse> {
		return new Promise<WeeekOptionsUpsertStatusesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'UpsertStatuses',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsUpsertStatusesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsUpsertStatusesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление/удаление/изменение сопоставления типов
	 */
	async upsertTagsAsync(request: WeeekOptionsUpsertTagsRequest): Promise<WeeekOptionsUpsertTagsResponse> {
		return new Promise<WeeekOptionsUpsertTagsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'UpsertTags',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsUpsertTagsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsUpsertTagsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение настроек проекта
	 */
	async getProjectOptionsAsync(request: WeeekOptionsGetProjectOptionsRequest): Promise<WeeekOptionsGetProjectOptionsResponse> {
		return new Promise<WeeekOptionsGetProjectOptionsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'GetProjectOptions',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsGetProjectOptionsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsGetProjectOptionsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сопоставления тегов
	 */
	async getTagsAsync(request: WeeekOptionsGetTagsRequest): Promise<WeeekOptionsGetTagsResponse> {
		return new Promise<WeeekOptionsGetTagsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'GetTags',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsGetTagsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsGetTagsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сопоставления типов
	 */
	async getTypesAsync(request: WeeekOptionsGetTypesRequest): Promise<WeeekOptionsGetTypesResponse> {
		return new Promise<WeeekOptionsGetTypesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'GetTypes',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsGetTypesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsGetTypesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сопоставления тегов
	 */
	async getStatusesAsync(request: WeeekOptionsGetStatusesRequest): Promise<WeeekOptionsGetStatusesResponse> {
		return new Promise<WeeekOptionsGetStatusesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'GetStatuses',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsGetStatusesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsGetStatusesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сопоставления тегов
	 */
	async getPrioritiesAsync(request: WeeekOptionsGetPrioritiesRequest): Promise<WeeekOptionsGetPrioritiesResponse> {
		return new Promise<WeeekOptionsGetPrioritiesResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Weeek',
				Controller: 'WeeekOptionsWsController',
				Method: 'GetPriorities',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<WeeekOptionsGetPrioritiesResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as WeeekOptionsGetPrioritiesResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}